import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../libs/contexts/authContext'
import { Navigate, useLocation } from 'react-router'
import DynamicView from './DynamicView'
import { getItem } from '../libs/utils/localForage'
import { useSelector } from 'react-redux'

const ProtectedDynamicView = ({ version1, version2, version3, isAppMngmt = false }) => {
  const { company, authObj } = useContext(AuthContext)
  // const [authObj, setAuthObj] = useState({ isAuthenticated: false })
  const loggedIn = useSelector((state) => state.auth.isAuthenticated)
  const location = useLocation()

  // const checkAuth = async () => {
  //   const storedState = await getItem('authObj')
  //   if (storedState) {
  //     setAuthObj(JSON.parse(storedState))
  //   } else {
  //     setAuthObj({ isAuthenticated: false })
  //   }
  // }

  if (
    (!authObj?.isAuthenticated && company === 'foresters') ||
    (!loggedIn && company === 'assure') ||
    (!authObj?.isAuthenticated && company === 'avant') ||
    (!loggedIn && isAppMngmt && company === 'sbli')
  )
    return <Navigate to="/login" state={{ ...location.state }} />
  else return <DynamicView version1={version1} version2={version2} version3={version3} />
}

export default ProtectedDynamicView
